import * as types from '../actions/ActionTypes';
import InitialState from './InitialState';
import { assign } from '../../../shared/Assign';
import moment from 'moment';

export default function calendarReducer(
    state: any = InitialState,
    action: { type: string; result: any }
) {
    let newState = assign({}, state);

    switch (action.type) {
        case types.GET_PHOTOGRAPHERS_BY_REGION_SUCCESS:
            newState = action.result;
            return newState;
        case types.GET_MULTIPLE_CALENDARS_SUCCESS:
            newState.calendars = action.result;
            newState.calendars.forEach((x) => {
                x.se360WorkingHours = x.se360WorkingHours.map((w) => {
                    w.start = moment(w.start, 'HH:mm:ss').toDate();
                    w.end = moment(w.end, 'HH:mm:ss').toDate();
                    return w;
                });

                x.scandphotosWorkingHours = x.scandphotosWorkingHours.map((w) => {
                    w.start = moment(w.start, 'HH:mm:ss').toDate();
                    w.end = moment(w.end, 'HH:mm:ss').toDate();
                    return w;
                });
            });
            return newState;
        case types.DELETE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            if (newState.calendars) {
                newState.calendars[0].items = newState.calendars[0].items.filter(
                    (x) => x.id !== action.result.id
                );
            }

            return newState;
        case types.UPDATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            if (newState.calendars) {
                let c = newState.calendars[0].items.filter((x) => x.id !== action.result.id);
                action.result.editable = true;
                c.push(action.result);
                newState.calendars[0].items = c;
            }

            return newState;
        case types.CREATE_PHOTOGRAPHER_CALENDAR_ITEM_SUCCESS:
            if (newState.calendars) {
                if (!newState.calendars[0].items) {
                    newState.calendars[0].items = [];
                }
                action.result.item.editable = true;
                if (action.result.id) {
                    action.result.item.id = action.result.id;
                }
                newState.calendars[0].items.push(action.result.item);
            }

            return newState;
        case types.UPDATE_PHOTOGRAPHER_CALENDAR_WORKING_HOURS_SUCCESS:
            newState.calendars[0].se360WorkingHours = action.result.se360WorkingHours.map((x) => {
                x.start = moment(x.start, 'HH:mm:ss').toDate();
                x.end = moment(x.end, 'HH:mm:ss').toDate();
                return x;
            });

            newState.calendars[0].scandphotosWorkingHours =
                action.result.scandphotosWorkingHours.map((x) => {
                    x.start = moment(x.start, 'HH:mm:ss').toDate();
                    x.end = moment(x.end, 'HH:mm:ss').toDate();
                    return x;
                });
            return newState;

        case types.GET_SMS_TEMPLATES_FOR_PHOTOGRAPHER:
            newState.smsTemplatesForPhotographer = action.result;
            return newState;

        case types.GET_EMAIL_TEMPLATES_FOR_PHOTOGRAPHER:
            newState.emailTemplatesForPhotographer = action.result;
            return newState;

        case types.GET_EMAIL_SENDERS_FOR_PHOTOGRAPHER:
            newState.emailSendersForPhotographer = action.result.senders;
            return newState;
        default:
            return state;
    }
}
